<div class="col-md-12 mb-30"  >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات اضافه کار</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> سال </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">سال 1403</option>
            <option value="1404">سال 1404</option>
            <option value="1405">سال 1405</option>
            <option value="1406">سال 1406</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ماه </label>
          <select [(ngModel)]="Filter_month" (change)="ReadData_Salary()" class="custom-select">
            <option value="1">فرودین</option>
            <option value="2">اردبیهشت</option>
            <option value="3">خرداد</option>
            <option value="4">تیر</option>
            <option value="5">مرداد</option>
            <option value="6">شهریور</option>
            <option value="7">مهر</option>
            <option value="8">آبان</option>
            <option value="9">آذر</option>
            <option value="10">دی</option>
            <option value="11">بهمن</option>
            <option value="12">اسفند</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>مدت اضافه کار(ساعت)</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Salary.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <input [(ngModel)]="item.ezakekarCount" type="number" />
              <td>
                <button (click)="SubmitAddNewSalary(item)" type="button" class="btn btn-success" style="margin-left: 5px;"><i
                  class="fa  fa-plus-circle"></i> ویرایش </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

